import usFlag from "../assets/images/flags/us.jpg"
import frFlag from "../assets/images/flags/french.jpg"

const languages = {
  en: {
    label: "English",
    flag: usFlag,
  },
  fr: {
    label: "French",
    flag: frFlag,
  },
}

export default languages
